import { Data } from "ws";
import { DataType } from "./DataType";

export class TypeMember
{
  name:string;
  type:DataType;

  static create( name:string, type:DataType )
  {
    let member = new TypeMember();
    
    member.name = name;
    member.type = type;

    return member;
  }
}